import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR, NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR, TAB_SIZE
} from "constants/ThemeSetting";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import Sidebar from "../Sidebar";

const SIDEBAR_VISIBLE_ON = [NAV_STYLE_FIXED, NAV_STYLE_DRAWER, NAV_STYLE_MINI_SIDEBAR, NAV_STYLE_NO_HEADER_MINI_SIDEBAR, NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR];

// eslint-disable-next-line react-refresh/only-export-components
const AppSidebar = ({navStyle}) => {
  
  const width = useSelector(({common}) => common.width);

  if (width < TAB_SIZE || SIDEBAR_VISIBLE_ON.includes(navStyle)) {
    return <Sidebar/>;
  }

  return null;
};

AppSidebar.propTypes = {
  navStyle: PropTypes.string
};

const memoizedAppSidebar = React.memo(AppSidebar);

export default memoizedAppSidebar;
